module.exports = __webpack_public_path__ + "static/media/5.faa1b5aa.jpg";